/**
 * corresponds to PD2_Campaigns::ASSET_SAVE_* constants
 */
export const CAMPAIGN_ASSET_SAVE_TYPE = {
	DRAFT: 'draft',
	PUBLISHED: 'published'
} as const;

export type TAssetSaveType = typeof CAMPAIGN_ASSET_SAVE_TYPE[keyof typeof CAMPAIGN_ASSET_SAVE_TYPE];

export const isValidAssetSaveType = (assetSaveType: string): boolean => {
	return Object.values(CAMPAIGN_ASSET_SAVE_TYPE).includes(assetSaveType as TAssetSaveType);
};
